import { graphql, useStaticQuery } from 'gatsby'
import '@src/data/prismic-fragments/event'
import { eventResolver, Event } from '@src/utils/resolvers'

export default () => {
  const data = useStaticQuery(graphql`
    {
      allPrismicEvent(sort: { fields: data___dagsetning, order: ASC }) {
        nodes {
          ...prismicEventFragmentFull
        }
      }
    }
  `)

  const events: any[] = data.allPrismicEvent.nodes.map((node: any) =>
    eventResolver(node)
  )
  let passed: Event[] = []
  let future: Event[] = []
  // Split events into past and future
  events.forEach(e => (e.passed ? passed : future).push(e))
  // Sort future events by ascending date but past events by descending order
  return future
    .sort((a, b) => a.date.getTime() - b.date.getTime())
    .concat(passed.sort((a, b) => b.date.getTime() - a.date.getTime()))
}
